import axios from "axios";

const normalizeUrl = (u) =>
  typeof u === "string" ? u.trim().replace(/\/+$/, "") : u;

const createApi = (baseURL) => {
  const instance = axios.create({
    baseURL: normalizeUrl(baseURL || process.env.REACT_APP_BACKEND_URL),
    withCredentials: true,
    timeout: 180000,
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0"
    }
  });

  // Injeta o JWT em TODA instância (inclusive as de multiplexing por
  // whatsapp.urlBackend). Sem isso, os envios feitos via apiCustom iam sem
  // Authorization e o backend não conseguia identificar o remetente (userId).
  // Lê o token fresco a cada request, espelhando o interceptor do useAuth.
  instance.interceptors.request.use(
    (config) => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`;
        }
      } catch (e) {
        // token ausente/ inválido no storage: segue sem Authorization
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
};

// Exporta uma instância padrão com a URL do .env
const api = createApi();

export default api;
export { createApi };